module.exports = __webpack_public_path__ + "img/aqmola5.214058f6.jpg";